
<template>
  <div>
    <v-row class="px-3 py-2" row wrap align='center' v-for="item in items" :key="item.id" style="border-bottom: solid #ccc 1px;" >
      <span class="mr-2">#{{item.id}}</span>
      <span class="mr-2">{{ Number(item[kind_value_key_map[kind]]).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}</span>

      <v-tooltip top>
        <template v-slot:activator="{on}">
          <v-icon v-on="on" :color="item.confirmed? 'success' : 'error'">{{item.confirmed? 'mdi-check' : 'mdi-close'}}</v-icon>
        </template>
        <span>{{item.confirmed? 'Confirmado' : 'Não confirmado'}}</span>
      </v-tooltip>
      <v-btn small text color="primary" @click="showDetails(item.id)">ver item</v-btn>
    </v-row>
    
    <dialog-item-details v-if="details" :kind="kind" :element_id="details_id" @close='handleClose'></dialog-item-details>
    
  </div>
</template>

<script>
import data_extract_mixin from '../data_extract_mixin'
import DialogItemDetails from './DialogItemDetails.vue'

export default {
  name: 'ItemsExtract',
  components: {
    DialogItemDetails,
  },
  props: {
    items: {
      type: Array,
    },
    kind: {
      type: String
    }
  },
  mixins: [data_extract_mixin],
  data() {
    return {
      key: null,
      kind_value_key_map: {
        bill: 'value',
        check: 'value',
        pix: 'paid_amount',
      },

      details_id: null,
      details: false,

      loading_bill: false
    }
  },
  methods: {
    handleClose() {
      this.details = false
      this.details_id = null
    },
    showDetails(id) {
      this.details_id = id
      this.details = true
    },
  },
}
</script>